import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import SquareButton from "../../../../../../../ui/SquareButton";
import AddButton from "../../../../../../../ui/AddButton";
import SearchField from "../../../../../../../ui/SearchField";
import ActionsMenu from "../../../../../../../ui/ActionsMenu";
import Box from "../../../../../../../ui/Box";
import AddConnectModal from "../AddConnectModal";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class ProgramConnectTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addConnectOpen: false,
      collapsed: false,
      selectedConnects: [],
      focusedConnect: -1,
      focusedRowIndex: -1
    };

    this.showAddModal = this.showAddModal.bind(this);
    this.selectConnects = this.selectConnects.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectConnects({ selectedRowsData }) {
    this.setState({ selectedConnects: selectedRowsData });
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  onRowClick(e) {
    const focusedConnect = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedConnect, focusedRowIndex });
  }

  showAddModal() {
    this.setState({ addConnectOpen: !this.state.addConnectOpen });
  }

  render() {
    const {
      addConnectOpen,
      selectConnects,
      focusedRowIndex,
      focusedConnect
    } = this.state;

    const {
      connectsData,
      classes,
      getConnects
    } = this.props;

    const { root, programContainer, controls } = classes;

    const programActions = [
      {
        label: "Удалить выбранные",
        disabled: true
      }
    ];

    return (
      <div className={root}>
        <div style={{margin:0}}>
          <AddConnectModal
            open={addConnectOpen}
            handleClose={this.showAddModal}
          />
          <div className={controls}>
            <div>
              <SquareButton>
                <CachedIcon fontSize="small"/>
              </SquareButton>
              <SearchField width={400} />
            </div>
            <div>
              <AddButton onClick={this.showAddModal}/>
              <ActionsMenu actions={programActions} />
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              dataSource={connectsData.itemsList}
              onSelectionChanged={this.selectConnects}
              focusedRowEnabled
              errorRowEnabled={false}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ProgramConnectTable);
